import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { IPermitTask, PermitTask } from '@core/entities/task/PermitTask'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const taskTransform = (tasksData: Array<IPermitTask>) => {
  return tasksData.map((task) => PermitTask.new(task))
}

export const usePermitTasks = (
  payload: RequestTypes['getPermitTasks'],
  options?: UseQueryOptions<PermitTask[], RequestErrorType>,
) => {
  return useQuery({
    select: taskTransform,
    ...permitKeys.byId(payload)._ctx.tasks,
    ...options,
  })
}
